import { type ReactNode, useId } from "react";

/**
 * A titled block: a rule, a heading, and an optional terminal function code.
 *
 * Replaces `rounded-md border border-border bg-surface-raised`, which appeared
 * in 18 files. Boxes nested inside boxes make every section compete for depth;
 * a rule states the same hierarchy with one line of ink. See docs/design.md,
 * "Rules, not boxes".
 */
export function Section({
  title,
  code,
  children,
}: {
  title: string;
  code?: string;
  children: ReactNode;
}) {
  const id = useId();
  return (
    <section aria-labelledby={id} className="flex flex-col gap-3 border-t-2 border-text pt-2">
      <div className="flex items-baseline justify-between gap-4">
        <h2 id={id} className="text-display-md">
          {title}
        </h2>
        {code ? <span className="text-label text-text-muted">{code}</span> : null}
      </div>
      {children}
    </section>
  );
}
